import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/security-setting';
import { ResultState } from '@rootCommon/types/common';
import { OrganizationSecuritySetting } from '@rootCommon/types/orgSecuritySetting';

type Action = ActionType<typeof actions>;
export type SecuritySettingState = ResultState<OrganizationSecuritySetting | null>;

const initState: SecuritySettingState = {
  data: null,
  loading: false,
  error: null,
};

export const securitySettingReducer = (state = initState, action: Action): SecuritySettingState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchSecuritySetting.request):
      return { ...state, loading: true };
    case getType(actions.fetchSecuritySetting.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.fetchSecuritySetting.failure):
      return {
        ...state, loading: false, error: action.payload, data: null,
      };

      // update
    case getType(actions.updateSecuritySetting.request):
      return { ...state, loading: true };
    case getType(actions.updateSecuritySetting.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.updateSecuritySetting.failure):
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default securitySettingReducer;
